import React, { useState, useEffect } from "react";
import languages from "../../languages";
import { Col, Row } from "reactstrap";
import { getLang } from "../../Values";
import Loading from "../../components/Loading/Loading";
import RequestServer from "../../RequestServer";
import errorsStrings from "../../Errors/errorsStrings";
import SweetAlert from "../../components/SweetAlert/SweetAlert";
import { Form, FormButton, FormInput } from "../../components/FormikComponents";
import * as Yup from "yup";
import noImage from "../../assets/icons/no-image-01.svg";
import ErrorPage from "../errors/403";
import DeactiveLink from "../errors/DeactiveLink";

const PaymentLink = (props) => {
  const [loading, setLoading] = useState(true);
  const [firstLoading, setFirstLoading] = useState(true);
  const [restricted, setRestricted] = useState(false);
  const [bootData, setBootData] = useState({});
  const [detail, setDetail] = useState("");
  const [formData, setFormData] = useState([]);
  const [sweetAlert, setSweetAlert] = useState(false);
  const [isDeactivated, setIsDeativated] = useState(false);

  const lang = getLang(props);

  useEffect(() => {
    document.body.classList.toggle("login-page");
    document.title = " Yekpay Link";
    if (lang === "fa") {
      document.body.classList.add("rtl", "menu-on-right");
      document.documentElement.classList.add("rtl-active");
    }
    checkIP();
  }, [lang]);

  const checkIP = () => {
    RequestServer(
      "post",
      "check-ip",
      () => {
        request();
      },
      {
        lang: lang,
        onAnyFailed: () => {
          setLoading(false);
          setRestricted(true);
          setFirstLoading(false);
        },
      }
    );
  };

  const request = () => {
    RequestServer(
      "post",
      "boot",
      (response) => {
        setBootData(response);
        makeRemoteRequest(response);
      },
      {
        post: { secret: "AppYek**175GHD@#" },
        lang: lang,
        onAnyFailed: () => {
          setLoading(false);
        },
      }
    );
  };

  const makeRemoteRequest = (bootData) => {
    const params = props.match.params;
    RequestServer(
      "post",
      "yekpay-link/show",
      (response) => {
        const { name, currency_id, amount, image, link, user } = response;
        const currency = bootData.currencies.find(
          (item) => item.id === currency_id
        );
        setDetail({ ...detail, name, currency, amount, image, link, user });
        setFirstLoading(false);
        setLoading(false);
      },
      {
        post: { payment_link_id: params.id, signature: params.signature },
        lang: lang,
        onAnyFailed: () => {
          setIsDeativated(true);
          setFirstLoading(false);
          setLoading(false);
        },
      }
    );
  };

  const trySweetAlert = () => {
    return (
      <SweetAlert
        type={"info"}
        onConfirm={() => pay(formData?.url)}
        confirmBtnText={languages[lang].continue}
        onCancel={() => setSweetAlert(false)}
        cancelTxt={languages[lang].cancel}
        showCancel="warning"
      >
        <p>{languages[lang].pay_try}</p>
        <p>
          {" You will pay in " +
            formData?.tryAmount +
            " TRY equivalent of " +
            detail.amount +
            " EUR (Exchange rate: " +
            formData?.rate +
            "). The charge will appear on your credit card statement as 'Online Payment' or 'BLS* S/ELEKSE YETKILI VEZNE OD' from Turkey. "}
        </p>
      </SweetAlert>
    );
  };

  const pay = (url) => {
    window.location = url;
  };

  const validate = (values) => {
    const params = props.match.params;

    const {
      firstName,
      lastName,
      email,
      mobile,
      address,
      country,
      postalCode,
      city,
      description,
      turkishID,
    } = values;

    setLoading(true);
    RequestServer(
      "post",
      "yekpay-link/start",
      (res) => {
        setFormData({ ...formData, res });
        if (res.redirect) {
          pay(res.url);
        } else {
          setSweetAlert(true);
          setLoading(false);
        }
      },
      {
        post: {
          currency_id: detail?.currency.id,
          amount: detail?.amount,
          payer_first_name: firstName,
          payer_last_name: lastName,
          payer_email: email,
          payer_mobile: mobile,
          payer_postal_code: postalCode,
          payer_country: country,
          payer_description: description,
          payer_city: city,
          payer_address: address,
          username: params.username,
          payer_turkish_id: turkishID,
          signature: params.signature,
          payment_link_id: params.id,
          lang: lang,
          source: "Website",
        },
        lang: lang,
        onAnyFailed: () => {
          setLoading(false);
        },
      }
    );
  };

  const errorGenerator = (label) => {
    return languages[lang][label] + " " + errorsStrings[lang].required;
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required(errorGenerator("firstName")),
    lastName: Yup.string().required(errorGenerator("lastName")),
    email: Yup.string()
      .email(errorsStrings[lang].emailIsNotValid)
      .required(errorGenerator("email")),
    mobile: Yup.string()
      .min(7, errorsStrings[lang].inputIsNotValid)
      .required(errorGenerator("mobile")),
    address: Yup.string().required(errorGenerator("address")),
    country: Yup.string().required(errorGenerator("country")),
    postalCode: Yup.string().required(errorGenerator("postalcode")),
    city: Yup.string().required(errorGenerator("city")),
    description: Yup.string().required(errorGenerator("description")),
    turkishID: Yup.string().when("isTRY", {
      is: true,
      then: Yup.string().required(errorGenerator("turkishID")),
    }),
  });

  if (firstLoading)
    return (
      <div
        className="d-flex  justify-content-center  align-items-center"
        style={{ height: "100vh" }}
      >
        <Loading lang={lang} />
      </div>
    );
  if (restricted) return <ErrorPage />;
  if (isDeactivated) return <DeactiveLink lang={lang} />;
  return (
    <>
      <div className="globalContainerForPaymentPage">
        <main>
          <div>
            <Row className="text-right mx-0">
              <Col lg="8" md="10" sm="12" xs="12" className="mx-auto">
                <Row className="mb-3">
                  <Col
                    lg="4"
                    md="12"
                    className={
                      lang === "fa"
                        ? "text-right" + " paymentLeft"
                        : "text-left" + " paymentLeft"
                    }
                  >
                    <div className="container">
                      <Row>
                        <h1 className="yekpaylink-h1-title">
                          {/*{languages[lang].yekpaylinktitle}*/}
                        </h1>
                      </Row>

                      <div className="row rowHolder mt-0">
                        <Col xl="12" md="12" lg="12">
                          <div className="imageDocument">
                            <div className="imageContainer">
                              <img
                                src={detail.image ? detail.image : noImage}
                                alt=""
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xl="12" lg="12" md="12" className="mx-0 px-0">
                          <div className="rowTop mt-4">
                            <div className="leftTitle">
                              {languages[lang].to}:
                            </div>
                            <div className="rightValue">
                              {detail.user.first_name} {detail.user.last_name}
                            </div>
                          </div>
                          <div className="rowTop">
                            <div className="leftTitle">
                              {languages[lang].for}:
                            </div>
                            <div className="rightValue">{detail.name}</div>
                          </div>
                        </Col>
                      </div>

                      <div className="row separatorRows"></div>

                      <div className="row rowHolder2">
                        <Col md="12">
                          <div className="rowDown">
                            {languages[lang].paycontactinfo}
                          </div>
                        </Col>
                        <Col md="12">
                          <div className="rowDown">
                            <div className="leftTitle">
                              <i className="fa fa-envelope"></i>
                            </div>
                            <div className="rightValue">
                              {detail.user.email}
                            </div>
                          </div>
                        </Col>
                        <Col md="12">
                          <div className="rowDown">
                            <div className="leftTitle">
                              <i className="fa fa-phone"></i>
                            </div>
                            <div className="rightValue">
                              {detail.user.mobile}
                            </div>
                          </div>
                        </Col>
                      </div>

                      {/*<div className="row rowImage">*/}
                      {/*  <img*/}
                      {/*    src={*/}
                      {/*      require("../../assets/img/logo-white.svg").default*/}
                      {/*    }*/}
                      {/*    alt=""*/}
                      {/*    className=""*/}
                      {/*  />*/}
                      {/*  <Col md="12 my-3">*/}
                      {/*    <div className="text-white">*/}
                      {/*      {languages[lang].paymentServiceProvider}*/}
                      {/*    </div>*/}
                      {/*  </Col>*/}
                      {/*</div>*/}
                    </div>
                  </Col>
                  <Col className="col-lg-8 col-md-12 p-0 m-0 ">
                    <div className="payment">
                      <h4
                        className={
                          lang === "fa"
                            ? "text-right text-danger col-12 px-0"
                            : "text-left text-primary col-12 paymentTitleDanger px-0"
                        }
                      >
                        <i
                          className="fa fa-exclamation-triangle"
                          style={{ margin: "0 5px" }}
                        ></i>
                        {languages[lang].yekpay_link_form_title}
                      </h4>

                      <Form
                        validationSchema={validationSchema}
                        initialValues={{
                          firstName: "",
                          lastName: "",
                          email: "",
                          mobile: "",
                          address: "",
                          country: "",
                          postalCode: "",
                          city: "",
                          description: "",
                          turkishID: "",
                          isTRY: detail?.currency.id === 18,
                        }}
                        onSubmit={(values) => validate(values)}
                      >
                        <Col className="d-flex justify-content-center py-3 px-2 flex-wrap">
                          <FormInput
                            name="firstName"
                            placeholder={languages[lang].firstName}
                            justEnglish
                          />
                          <FormInput
                            name="lastName"
                            placeholder={languages[lang].lastName}
                            justEnglish
                          />
                          <FormInput
                            name="email"
                            icon="fal fa-envelope"
                            placeholder={languages[lang].email}
                            justEnglish
                            dir="ltr"
                          />
                          <FormInput
                            name="mobile"
                            icon="fal fa-mobile"
                            placeholder={languages[lang].mobile}
                            justEnglish
                          />
                          {detail?.currency?.id === 18 ? (
                            <FormInput
                              name="turkishID"
                              icon="far fa-address-card"
                              placeholder={languages[lang].turkishID}
                              justEnglish
                            />
                          ) : (
                            <FormInput
                              name="address"
                              icon="fal fa-map-marker-alt"
                              placeholder={languages[lang].address}
                              justEnglish
                            />
                          )}

                          <FormInput
                            name="country"
                            icon="fal fa-flag"
                            placeholder={languages[lang].country}
                            justEnglish
                          />
                          <FormInput
                            name="city"
                            placeholder={languages[lang].city}
                            justEnglish
                            icon="fal fa-flag"
                          />
                          <FormInput
                            name="postalCode"
                            placeholder={languages[lang].postalcode}
                            justEnglish
                            icon="fal fa-mailbox"
                          />
                          {detail?.currency.id === 18 && (
                            <FormInput
                              icon="fal fa-map-marker-alt"
                              name="address"
                              justEnglish
                              placeholder={languages[lang].address}
                              col="12"
                            />
                          )}
                          <FormInput
                            col="12"
                            name="description"
                            justEnglish
                            textarea
                            placeholder={
                              languages[lang]
                                .yekpayLinkDPayerescriptionPlaceholder
                            }
                            icon="fal fa-comment-alt"
                          />
                          <div className="d-flex flex-column align-items-center mt-3 mb-1">
                            <FormButton
                              text={
                                languages[lang].pay +
                                " " +
                                detail?.amount +
                                " " +
                                detail?.currency.symbol
                              }
                              loading={loading}
                            />
                          </div>
                        </Col>
                      </Form>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="container">
            <div className="col-md-12 text-center">
              <img
                src={require("../../assets/img/card-familys.png")}
                alt="logos"
                width="300"
              />
            </div>
          </div>
          <div className="col-12 d-flex justify-content-center my-3">
            {lang === "en" ? (
              <p className="copyright text-primary">
                Copyright © <b>Yekpay.</b> All Rights Reserved.
              </p>
            ) : (
              <p className="copyright text-primary">
                کلیه حقوق متعلق به وبسایت <b>یک پی</b> می باشد
              </p>
            )}
          </div>
        </main>
      </div>
      {sweetAlert && trySweetAlert()}
    </>
  );
};

export default PaymentLink;
